// extracted by mini-css-extract-plugin
export var label = "_s3-0";
export var link = "_s3-1";